import React from "react"
import styles from './index.module.scss'
import Avatar from "../Avatar";
import InfoTooltip from '../InfoTooltip'

interface UsersAvatarProps{
    avatarsCount?: number,
    users: any[],
    compact?: boolean,
}

export default function UsersAvatar({ users, avatarsCount = 3, compact = false }: UsersAvatarProps){
    const usersInitial = users?.filter((_, index) => index < avatarsCount) || [];

    const getUserName = (user: any) => {
        const nestedUser = user?.user || user?.profile || {}
        const directName = [user?.first_name, user?.last_name].filter(Boolean).join(' ')
        const nestedName = [nestedUser?.first_name, nestedUser?.last_name].filter(Boolean).join(' ')

        return directName
            || nestedName
            || user?.full_name
            || nestedUser?.full_name
            || user?.name
            || nestedUser?.name
            || user?.email
            || nestedUser?.email
            || ''
    }


    if(!users?.length){
        return null
    }

    return (
        <div className={styles.users}>
            {usersInitial.map((user: any) => {
                const userName = getUserName(user)
                const avatar = (
                    <div
                        className={`${styles.users__avatar} ${compact ? styles.users__avatarCompact : ''}`}
                        aria-label={userName || undefined}
                    >
                        <Avatar user={user}/>
                    </div>
                )

                return userName ? (
                    <InfoTooltip
                        key={String(user?.id || user?.user_id || user?.email || `${user?.first_name || ''}-${user?.last_name || ''}`)}
                        content={userName}
                    >
                        {avatar}
                    </InfoTooltip>
                ) : (
                    <React.Fragment key={String(user?.id || user?.user_id || `${user?.first_name || ''}-${user?.last_name || ''}`)}>
                        {avatar}
                    </React.Fragment>
                )
            })}
            {users.length > avatarsCount && (
                <div className={`${styles.users__avatar} ${compact ? styles.users__avatarCompact : ''}`}>
                    <div className={styles.users__avatar_count}>
                        +{users.length - avatarsCount}
                    </div>
                </div>
            )}
        </div>
    )
}

